import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Nav,
  Tab,
  Card,
  Badge,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { listProductDetails, fetchAllProducts } from "../../actions/product";
import { Link } from "react-router-dom";
import { Image } from "cloudinary-react";
import RichTextReader from "./richText";
import ScrollToTopWithTitle from "../../Utils/scrollToTop";
import "./style.css";

// Define chip colors
const CHIP_COLORS = [
  { bg: "#007bff", text: "#fff" }, // Blue
  { bg: "#28a745", text: "#fff" }, // Green
  { bg: "#dc3545", text: "#fff" }, // Red
  { bg: "#ffc107", text: "#000" }, // Yellow
  { bg: "#17a2b8", text: "#fff" }, // Cyan
  { bg: "#6610f2", text: "#fff" }, // Purple
  { bg: "#e83e8c", text: "#fff" }, // Pink
  { bg: "#fd7e14", text: "#fff" }, // Orange
];

const ProductDetail = ({ history, match }) => {
  const [selectedCapacity, setSelectedCapacity] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [showImage, setShowImage] = useState("");
  //
  const [selectedAmount, setSelectedAmount] = useState(0);

  const dispatch = useDispatch();
  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;

  const productList = useSelector((state) => state.productList);

  const { products } = productList;

  useEffect(() => {
    dispatch(listProductDetails(match.params.id));
  }, [dispatch, match]);

  // bring all products to be shown in the similar items
  useEffect(() => {
    dispatch(fetchAllProducts(match.params.keyword, 1));
  }, [dispatch]);

  const addToCartHandler = () => {
    history.push(
      `/cart/${match.params.id}?qty=${selectedAmount}&size=${
        selectedCapacity.split(" ")[0]
      }&=${selectedColor}`
    );
  };

  const [selectedProduct, setSelectedProduct] = useState();
  const [specificColorItem, setSpecificColorItem] = useState();

  useEffect(() => {
    if (product && product.capacity) {
      const showingDefaultFirstItem = product.capacity[0];
      const firstItemDetails = product.capacity[0].details;

      setSelectedCapacity(showingDefaultFirstItem.capacity + " GB");
      setSelectedColor(firstItemDetails[0].color);
      setSelectedQuantity(firstItemDetails[0].quantity);
      setShowImage(firstItemDetails[0].images[0].url);
      //
      setSelectedProduct({ ...showingDefaultFirstItem });
    }
  }, [product]);

  useEffect(() => {
    if (selectedCapacity && product) {
      const foundRecord = product.capacity.find(
        (item) => item.capacity === selectedCapacity.split(" ")[0]
      );
      if (foundRecord) {
        setSelectedColor(foundRecord.details[0].color);
        setSelectedCapacity(foundRecord.capacity + " GB");
        setShowImage(foundRecord.details[0].images[0].url);
        setSelectedQuantity(foundRecord.details[0].quantity);
        //
        setSelectedProduct({ ...foundRecord });
      }
    }
  }, [product, selectedCapacity]);

  useEffect(() => {
    if (selectedColor) {
      const foundRecordAccToColor = selectedProduct.details.find(
        (item) => item.color === selectedColor
      );
      setShowImage(foundRecordAccToColor.images[0].url);
      setSelectedQuantity(foundRecordAccToColor.quantity);
      setSpecificColorItem(foundRecordAccToColor);
    }
  }, [selectedProduct, selectedColor]);
  return (
    <>
      <ScrollToTopWithTitle
        title={product ? product.productName + " - Datacom" : "product screen"}
      />
      <section className="py-5">
        <Container>
          <Row className="gx-5">
            <Col lg={6}>
              <div className="border rounded-4 mb-3 d-flex justify-content-center">
                {/* display-image */}
                <Image
                  cloudName={"dljielsye"}
                  publicId={showImage}
                  style={{
                    maxWidth: "100%",
                    height: "500px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-3">
                {specificColorItem &&
                  specificColorItem.images.map((item3, index) => (
                    <Image
                      key={index}
                      width="auto"
                      height="100"
                      className="rounded-2 border mx-1"
                      cloudName="dljielsye"
                      publicId={item3.url}
                      onClick={() => setShowImage(item3.url)}
                      style={{ cursor: "pointer" }}
                    />
                  ))}
              </div>
            </Col>
            <Col lg={6}>
              <div className="ps-lg-3">
                <h4 className="title">
                  {!product ? "loading" : product.productName}
                </h4>
                <div className="d-flex flex-row my-3">
                  <div className="text-warning mb-1 me-2">
                    {Array(product ? product.rating : 0)
                      .fill()
                      .map((_, i) => (
                        <i key={i} className="fa fa-star"></i>
                      ))}
                    {/* <i className="fas fa-star-half-alt"></i> */}
                    <span className="ms-1">
                      {!product ? "loading" : product.rating}
                    </span>
                  </div>
                  <span className="text-muted">
                    <i className="fas fa-shopping-basket fa-sm mx-1"></i>
                    {selectedQuantity} items
                  </span>
                  <span className="text-success ms-2">
                    {selectedQuantity !== 0 ? "In" : "Out of"} stock
                  </span>
                </div>
                <div className="mb-3">
                  {!specificColorItem ? (
                    <span className="h5">Loading...</span>
                  ) : specificColorItem.discount > 0 ? (
                    <>
                      <span className="h5 text-danger">
                        $
                        {specificColorItem &&
                          specificColorItem.price - specificColorItem.discount}
                      </span>
                      {"  "}
                      <span className="text-muted text-decoration-line-through">
                        ${specificColorItem.price}
                      </span>
                      <span
                        className="badge bg-success ms-2"
                        style={{
                          backgroundColor: "#ff4d4f",
                          color: "white",
                          fontWeight: "bold",
                          padding: "4px 8px",
                          borderRadius: "5px",
                          fontSize: "1.2rem",
                        }}
                      >
                        {Math.round(
                          (specificColorItem.discount /
                            specificColorItem.price) *
                            100
                        )}
                        % OFF
                      </span>
                    </>
                  ) : (
                    <span className="h5">${specificColorItem.price}</span>
                  )}
                </div>

                <p>{!product ? "loading" : product.feature}</p>

                <div className="row">
                  <dt className="col-3">Capacity:</dt>
                  <dd className="col-9">{selectedCapacity}</dd>

                  <dt className="col-3">Color</dt>
                  <dd
                    className="col-9"
                    style={{
                      textTransform: "capitalize",
                    }}
                  >
                    {selectedColor}
                  </dd>

                  {/* <dt className="col-3">Material</dt>
                  <dd className="col-9">
                    {!product ? "loading" : product.material}
                  </dd> */}

                  <dt className="col-3">Brand</dt>
                  <dd className="col-9">
                    {!product ? "loading" : product.category}
                  </dd>

                  {product &&
                    product.carrierComp &&
                    product.carrierComp.length > 0 && (
                      <>
                        <dt className="col-3">Carrier Compatibility</dt>
                        <dd
                          className="col-9"
                          style={{
                            marginBottom: 0,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {
                            <div
                              className="d-flex flex-wrap"
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              {product.carrierComp.map((carrier, index) => {
                                const randomColor =
                                  CHIP_COLORS[
                                    Math.floor(
                                      Math.random() * CHIP_COLORS.length
                                    )
                                  ];

                                return (
                                  <Badge
                                    key={index}
                                    pill
                                    bg="error"
                                    className="d-flex align-items-center"
                                    style={{
                                      backgroundColor: randomColor.bg,
                                      color: randomColor.text,
                                      padding: "8px 12px",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    {carrier}
                                  </Badge>
                                );
                              })}
                            </div>
                          }
                        </dd>
                      </>
                    )}
                </div>

                <hr />

                <Row className="mb-4">
                  <Col md={4} xs={6}>
                    <Form.Group>
                      <Form.Label>Capacity</Form.Label>
                      <Form.Select
                        className="border border-secondary"
                        style={{ height: "35px" }}
                        value={selectedCapacity}
                        onChange={(e) => setSelectedCapacity(e.target.value)}
                      >
                        {loading
                          ? "loading"
                          : product &&
                            product.capacity.map((item) => (
                              <option>{item.capacity} GB</option>
                            ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4} xs={6}>
                    <Form.Group>
                      <Form.Label>Colors</Form.Label>
                      <Form.Select
                        className="border border-secondary"
                        style={{ height: "35px" }}
                        value={selectedColor}
                        onChange={(e) => setSelectedColor(e.target.value)}
                      >
                        {!selectedProduct
                          ? "loading"
                          : selectedProduct.details.map((item) => (
                              <option>{item.color}</option>
                            ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {/*  */}
                  <Col md={4} xs={6}>
                    <Form.Group>
                      <Form.Label>Quantity</Form.Label>
                      <InputGroup>
                        {/* Decrease Button */}
                        <Button
                          variant="white"
                          className="border border-secondary px-3"
                          onClick={() =>
                            setSelectedAmount((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={selectedAmount <= 1}
                        >
                          <i className="fas fa-minus"></i>
                        </Button>

                        {/* Quantity Input */}
                        <Form.Control
                          className="text-center border border-secondary"
                          type="number"
                          value={selectedAmount}
                          min="1"
                          max={selectedQuantity}
                          onChange={(e) => {
                            const value = parseInt(e.target.value, 10);
                            if (!isNaN(value)) {
                              setSelectedAmount(
                                Math.max(1, Math.min(value, selectedQuantity))
                              ); // Ensure within range
                            }
                          }}
                          disabled={
                            selectedAmount >= selectedQuantity ||
                            selectedQuantity === 0
                          }
                        />

                        {/* Increase Button */}
                        <Button
                          variant="white"
                          className="border border-secondary px-3"
                          onClick={() =>
                            setSelectedAmount((prev) =>
                              Math.min(prev + 1, selectedQuantity)
                            )
                          }
                          disabled={selectedAmount >= selectedQuantity}
                        >
                          <i className="fas fa-plus"></i>
                        </Button>
                      </InputGroup>

                      {/* Available Quantity Text */}
                      <Form.Text className="text-muted">
                        {selectedQuantity} items available
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  variant="primary"
                  className="shadow-0 me-2"
                  onClick={addToCartHandler}
                  disabled={!selectedAmount}
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    border: "1px solid black",
                    paddingLeft: "2rem",
                    paddingRight: "2rem",
                    textAlign: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#514f4f";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "black";
                    e.target.style.color = "white";
                  }}
                >
                  <i className="me-1 fa fa-shopping-basket"></i> Add to cart
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="bg-light border-top py-4">
        <Container>
          <Row className="gx-4">
            <Col lg={8} className="mb-4">
              <div className="border rounded-2 py-2 bg-white">
                <Tab.Container defaultActiveKey="specification">
                  <Nav variant="pills" className="nav-justified mb-3">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="specification"
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          textAlign: "left",
                          fontWeight: "600",
                          fontSize: "22px",
                        }}
                      >
                        Specification
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="specification">
                      <RichTextReader richTextContent={product?.richText} />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </Col>
            <Col lg={4}>
              <div className="px-0 border rounded-2 shadow-0">
                <Card>
                  <Card.Body>
                    <Card.Title>Similar items</Card.Title>
                    {products &&
                      products.slice(0, 4).map((item, index) => (
                        <Link
                          to={`/product/${item._id}?`}
                          style={{
                            textDecoration: "none",
                          }}
                        >
                          <div className="d-flex mb-3" key={index}>
                            <div
                              href="#"
                              className="me-3 img-thumbnail"
                              style={{
                                width: "100px",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Image
                                style={{
                                  // maxWidth: "100%",
                                  width: "auto",
                                  height: "120px",
                                  objectFit: "contain",
                                }}
                                className="img-md "
                                cloudName={"dljielsye"}
                                publicId={item.image[0]}
                              />
                            </div>
                            <div
                              className="info"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <p
                                style={{
                                  textDecoration: "none",
                                  padding: 0,
                                  margin: 0,
                                  color: "#0d6efd",
                                }}
                              >
                                {item.productName}
                              </p>
                              <strong className="text-dark">
                                ${item.capacity[0].details[0].price}
                              </strong>
                            </div>
                          </div>
                        </Link>
                      ))}
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ProductDetail;
